/** Sentry settings resolved from webpack build constants (see `webpackConstants/*`). */
export const sentryConfig = {
  enabled: SENTRY_ENABLED,
  dsn: SENTRY_DSN,
  release: SENTRY_RELEASE,
  environment: ENV,
  sdkVersion: VERSION,
  errorSampleRate: SENTRY_ERROR_SAMPLE_RATE,
  maxEventsPerSession: SENTRY_MAX_EVENTS_PER_SESSION,
  logsEnabled: SENTRY_LOGS_ENABLED,
  logsSampleRate: SENTRY_LOGS_SAMPLE_RATE,
  maxBreadcrumbs: 50,
} as const;
